import instance from "../utils/network";
export interface NotificationListResponse {
  list: NotificationResponse[];
}
export interface NotificationResponse {
  id: number;
  type: NotificationType;
  title?: string;
  content: string;
  isRead: boolean;
  elapsedTime: number;
  goToPage: string;
}

export interface NotificationSettingResponse {
  id: number;
  userId: number;
  isPushEnabled: boolean;
}

export enum NotificationType {
  SYSTEM = "system",
  COMMENT = "comment",
  WALLET = "wallet",
  TOURNAMENT = "tournament",
}

export function getNoticesListAndRead(): Promise<NotificationListResponse> {
  return instance.get(`/nest/user-notifications/list`);
}

export function getHasUnreadNotifications(): Promise<boolean> {
  return instance.get(`/nest/user-notifications/has-unread-notifications`);
}

export function getNotificationSetting(): Promise<NotificationSettingResponse> {
  return instance.get(`/nest/user-notifications/setting`);
}

export function updateNotificationSetting(
  isPushEnabled: boolean
): Promise<NotificationSettingResponse> {
  const data = {
    isPushEnabled,
  };
  return instance.put(`/nest/user-notifications/setting`, data);
}
